<template>
  <div class="container-fluid mt-4">

    <router-view> </router-view>

  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {

    }
  },
  methods: {

  }
}

</script>
